import { Skeleton } from '@/components/ui/skeleton';
import { Separator } from '@/components/ui/separator';

export function JobSkeleton() {
  return (
    <div>
      <div className="space-y-3">
        {/* Job Header */}
        <div className="space-y-2">
          <div className="flex items-start justify-between gap-2">
            {/* Job Title */}
            <Skeleton className="h-5 w-3/5" />
            {/* Job Type Badge */}
            <Skeleton className="h-5 w-20 rounded-full" />
          </div>
          {/* Company */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-3 w-3 rounded" />
            <Skeleton className="h-3 w-32" />
          </div>
        </div>

        {/* Job Details */}
        <div className="space-y-1.5">
          {/* Location */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-3 w-3 rounded" />
            <Skeleton className="h-3 w-40" />
          </div>
          {/* Salary */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-3 w-3 rounded" />
            <Skeleton className="h-3 w-36" />
          </div>
          {/* Posted Date */}
          <div className="flex items-center gap-2">
            <Skeleton className="h-3 w-3 rounded" />
            <Skeleton className="h-3 w-24" />
          </div>
        </div>

        {/* Job Description */}
        <div className="space-y-1">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-4/5" />
        </div>

        {/* Action Button */}
        <Skeleton className="h-8 w-full rounded-md" />
      </div>

      {/* Separator */}
      <Separator className="mt-4" />
    </div>
  );
}
